function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["application"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import sprintf from 'sprintf-js';
import featureEnabled from 'shared/helper/feature';
/**
 * Returns the language component of a given url, falling back to
 * a state variable, or english
 */

export var getLanguage = function getLanguage() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var explicitMatchesOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var restrictLanguages = featureEnabled('rubriq_restrict_languages');
  var _ref = window.AppData || {},
    siteLanguage = _ref.siteLanguage;
  var matches = link.match(/\/(cn|jp|en|br|es)\//);
  if (matches) {
    var lang = matches[1];
    if (restrictLanguages && ['jp', 'br', 'es'].includes(lang)) {
      var newPath = window.location.pathname.replace(/^\/(jp|br|es)/, '/en');
      window.location.replace("".concat(newPath).concat(window.location.search));
      return 'en';
    }
    if (window.AppData) {
      window.AppData.siteLanguage = lang;
    }
    return lang;
  }
  if (explicitMatchesOnly) {
    return null;
  }
  var normalizedSiteLanguage = siteLanguage || 'en';
  if (restrictLanguages && ['jp', 'br', 'es'].includes(normalizedSiteLanguage)) {
    normalizedSiteLanguage = 'en';
  }
  if (window.AppData) {
    window.AppData.siteLanguage = normalizedSiteLanguage;
  }
  return normalizedSiteLanguage;
};
export var parseQueryParams = function parseQueryParams(url) {
  var params = {};
  if (!url.match(/\?.*=/)) {
    return params;
  }
  url.replace(/^\?/, '').split('&').map(function (queryString) {
    return queryString.split('=');
  }).forEach(function (keyValueArr) {
    params[keyValueArr[0]] = decodeURIComponent(keyValueArr[1]).replace(/\+/g, ' ');
  });
  return params;
};
export var generateAuthLink = function generateAuthLink(path, referringUrl, origin) {
  var authLink = referringUrl ? "/".concat(path, "?redirect=").concat(referringUrl) : "/".concat(path);
  if (origin) {
    authLink = authLink.concat(referringUrl ? '&' : '?', "origin=".concat(origin));
  }
  return authLink;
};
export var parameterize = function parameterize(params) {
  return Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(params[key] || ''));
  }).join('&');
};
export var getLink = function getLink(props) {
  var _links$params$linkNam, _ref2, _link$language;
  var _props$application = props.application,
    language = _props$application.siteLanguage,
    links = _props$application.config.links,
    params = _objectWithoutProperties(props, _excluded);
  if (!links) {
    return null;
  }
  var link = (_links$params$linkNam = links[params.linkName]) !== null && _links$params$linkNam !== void 0 ? _links$params$linkNam : null;
  if (!link) {
    return null;
  }
  var linkForLanguage = (_ref2 = (_link$language = link[language]) !== null && _link$language !== void 0 ? _link$language : link.default) !== null && _ref2 !== void 0 ? _ref2 : link;
  return sprintf.sprintf(linkForLanguage, _objectSpread({
    language: language
  }, params));
};